import { render, staticRenderFns } from "./DownloadResult.vue?vue&type=template&id=5d25a013"
import script from "./DownloadResult.vue?vue&type=script&lang=js"
export * from "./DownloadResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports